// @flow
import React, { Fragment } from 'react';
import { Row, Col } from 'Components/Grid';
import DealerModel from 'Stores/DealerModel';
import styles from './styles.scss';
import Icon from 'Components/Icon';

type Props = {
  dealer: DealerModel,
};

class DeactivatedServiceMessage extends React.Component<Props> {
  render() {
    const { dealer, showRedesignedLeadForms } = this.props;
    window.deactivatedServiceMessage = true;

    let whatsappUrl =
      dealer.settings && dealer.settings.whatsappWidget && dealer.settings.whatsappWidget.isActive
        ? dealer.settings.whatsappWidget.whatsappUrl
        : undefined;

    return (
      <div
        style={{
          padding: showRedesignedLeadForms ? '45px 0' : undefined,
        }}
      >
        <Row>
          <Col cols={12}>
            <h2
              id="modal-headline"
              aria-label="Wartungsarbeiten"
              className={styles.deactivatedHeadline}
            >
              Wartungsarbeiten
            </h2>
          </Col>

          <Col cols={12} className={styles.deactivatedText}>
            <p>
              Dieser Service steht Ihnen temporär nicht zur Verfügung. Vielen Dank für Ihr
              Verständnis.
            </p>
            <p>In der Zwischenzeit können Sie uns gerne direkt kontaktieren:</p>
          </Col>

          <Col cols={12}>
            <div className={styles.deactivatedMessageSeparationLine}></div>
          </Col>

          <Col cols={12}>
            <ul className={styles.deactivatedAddress}>
              <li className={styles.deativatedContactRow}>
                <h3 aria-label={dealer.name} className={styles.dealerName}>
                  {dealer.name}
                </h3>
              </li>
              <li className={styles.deativatedContactRow}>
                <span className={styles.iconWrapper}>
                  <Icon name="phone" />
                </span>

                <div className={styles.deativatedContactText}>
                  <a
                    href={`tel:${dealer.mainContact.phone}`}
                    aria-label={`Telefonnummer ${dealer.mainContact.phone.substring(0, 3) === '+49' && 'Deutschland'} ${dealer.mainContact.phone} anrufen`}
                  >
                    {dealer.mainContact.phone}
                  </a>
                </div>
              </li>
              <li className={styles.deativatedContactRow}>
                <span className={styles.iconWrapper}>
                  <Icon name="mail" />
                </span>

                <div className={styles.deativatedContactText}>
                  <a
                    href={`mailto:${dealer.mainContact.email}`}
                    aria-label={`E-Mail an ${dealer.mainContact.email} senden`}
                  >
                    {dealer.mainContact.email}
                  </a>
                </div>
              </li>

              {whatsappUrl && (
                <li className={styles.deativatedContactRow}>
                  <span className={styles.iconWrapper}>
                    <img
                      role="presentation"
                      className={styles.whatsappIcon}
                      src={`${process.env.ASSET_ENV_HOST}/assets/img/icon_whatsapp_green.svg`}
                    />
                  </span>

                  <div className={styles.deativatedContactText}>
                    <a
                      href={whatsappUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="WhatsApp Chat starten - öffnet in einem neuen Fenster oder Tab"
                    >
                      WhatsApp Chat starten
                    </a>
                  </div>
                </li>
              )}
            </ul>
          </Col>
        </Row>
      </div>
    );
  }
}

export default DeactivatedServiceMessage;
